/* eslint-disable no-unused-vars */
'use client'

import { create, StoreApi, UseBoundStore } from 'zustand'

import { getFacebookLoginStatus } from '@/services/facebook-service'
export interface ILimitedProps {
  isFacebookLoggedIn: boolean
}

const useFacebookStore: UseBoundStore<
  StoreApi<{
    isFacebookLoggedIn: boolean | undefined | null
    fetch: () => Promise<void>
    setIsFacebookLoggedIn: (data: boolean) => void
  }>
> = create((set) => ({
  isFacebookLoggedIn: undefined,
  setIsFacebookLoggedIn: (isFacebookLoggedIn: boolean | null) => set({ isFacebookLoggedIn }),
  fetch: async () => {
    // const res = await getFacebookLoginStatus()
    // set({ isFacebookLoggedIn: res.data?.isLoggedIn })
  },
}))

const setFacebookLoginStatus = async (value: boolean) => {
  useFacebookStore.getState().setIsFacebookLoggedIn(value)
}

export { useFacebookStore, setFacebookLoginStatus }
